/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdminProjectRowData } from './AdminProjectRowData';
import {
    AdminProjectRowDataFromJSON,
    AdminProjectRowDataFromJSONTyped,
    AdminProjectRowDataToJSON,
    AdminProjectRowDataToJSONTyped,
} from './AdminProjectRowData';

/**
 * 
 * @export
 * @interface AdminProjectPageData
 */
export interface AdminProjectPageData {
    /**
     * 
     * @type {Array<AdminProjectRowData>}
     * @memberof AdminProjectPageData
     */
    items?: Array<AdminProjectRowData>;
    /**
     * 
     * @type {number}
     * @memberof AdminProjectPageData
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminProjectPageData
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminProjectPageData
     */
    total?: number;
}

/**
 * Check if a given object implements the AdminProjectPageData interface.
 */
export function instanceOfAdminProjectPageData(value: object): value is AdminProjectPageData {
    return true;
}

export function AdminProjectPageDataFromJSON(json: any): AdminProjectPageData {
    return AdminProjectPageDataFromJSONTyped(json, false);
}

export function AdminProjectPageDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminProjectPageData {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(AdminProjectRowDataFromJSON)),
        'page': json['page'] == null ? undefined : json['page'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'total': json['total'] == null ? undefined : json['total'],
    };
}

export function AdminProjectPageDataToJSON(json: any): AdminProjectPageData {
    return AdminProjectPageDataToJSONTyped(json, false);
}

export function AdminProjectPageDataToJSONTyped(value?: AdminProjectPageData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(AdminProjectRowDataToJSON)),
        'page': value['page'],
        'pageSize': value['pageSize'],
        'total': value['total'],
    };
}

